import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { DefaultSeo } from 'next-seo';
import GTM from 'react-gtm-module';
import { initFingerprint } from '_helpers/fingerprint';
import { initVisitTracking } from '_helpers/location';

import 'styles/index.css';

import { config } from '_config';
import { theme } from '_constants/theme';
import { wrapper } from '_redux/store';

import PageLayout from '_components/composed/layouts/PageLayout';

function App({ Component, ...restProps }) {
  const { store, props } = wrapper.useWrappedStore(restProps);
  const router = useRouter();

  useEffect(() => {
    import('bootstrap/dist/js/bootstrap');
    GTM.initialize({ gtmId: config.gtmId });
    initFingerprint();
  }, []);

  useEffect(() => {
    if (!router.isReady) return;
    initVisitTracking(router);
  }, [router.isReady, router.asPath]);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <PageLayout>
          <DefaultSeo
            titleTemplate="%s | Trademark-Genius"
            defaultTitle="Trademark-Genius"
          />
          <Component {...props.pageProps} />
        </PageLayout>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
